var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78075 27.7923C6.32225 27.7923 4.24417 26.9319 2.5465 25.2111C0.848833 23.4903 0 21.4109 0 18.9731C0 16.6474 0.809617 14.6186 2.42885 12.8866C4.04808 11.1545 6.0218 10.2551 8.35 10.1884C8.64487 7.54228 9.8641 5.18267 12.0077 3.1096C14.1513 1.03653 16.5628 0 19.2423 0C19.6577 0 20.018 0.122434 20.3231 0.3673C20.6282 0.612167 20.7808 0.925633 20.7808 1.3077V17.0846L25.3539 12.4731L26.4654 13.623L20.0115 20.0385L13.5962 13.623L14.7077 12.4731L19.2423 17.0846V1.4423C16.5808 1.50127 14.3244 2.59935 12.4731 4.73655C10.6218 6.87372 9.69615 9.20512 9.69615 11.7308H8.7077C6.7381 11.7308 5.05083 12.4346 3.6459 13.8423C2.24093 15.25 1.53845 16.9731 1.53845 19.0116C1.53845 21.05 2.24998 22.7667 3.67305 24.1616C5.09615 25.5564 6.80225 26.2539 8.79135 26.2539H33.2423C34.691 26.2539 35.9231 25.7441 36.9384 24.7246C37.9538 23.705 38.4616 22.4794 38.4616 21.0476C38.4616 19.6159 37.9538 18.3923 36.9384 17.3769C35.9231 16.3615 34.6865 15.8539 33.2288 15.8539H30.1693V11.7308C30.1693 9.79742 29.7218 8.07627 28.8269 6.5673C27.932 5.05833 26.759 3.84615 25.3077 2.93075V1.18075C27.3154 2.12178 28.884 3.5487 30.0134 5.4615C31.143 7.37433 31.7077 9.46408 31.7077 11.7308V14.3154H32.9384C34.9025 14.2231 36.5705 14.8231 37.9423 16.1154C39.3141 17.4077 40 19.0474 40 21.0346C40 22.8987 39.3398 24.491 38.0193 25.8116C36.6987 27.1321 35.1064 27.7923 33.2423 27.7923H8.78075Z",
    fill: "#9AD9DC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.052e23f28ae7a7c5f6671587d2a72ace.svg";
export { ForwardRef as ReactComponent };